  function getCurrentCurrency() {
    return (
      window.Shopify?.currency?.active ||
      window.Currency?.currentCurrency ||
      null
    );
  }

  function updateBannerVisibility() {
    const currency = getCurrentCurrency();
    const banners = document.querySelectorAll(".usd-banner");

    if (currency && currency !== "USD") {
      banners.forEach(b => b.style.display = "none");
    } else {
      banners.forEach(b => b.style.display = "block");
    }
  }

  document.addEventListener("DOMContentLoaded", function () {
    updateBannerVisibility();

    let attempts = 0;
    const interval = setInterval(() => {
      updateBannerVisibility();
      attempts++;
      if (attempts > 10) clearInterval(interval);
    }, 300);

    document.addEventListener("currencyChange", updateBannerVisibility);
  });
